<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span class="calibre5">Clifford’s Blues</span></p>
<p class="authorname"><span class="calibre5">John A. Williams</span></p>
<p class="publisher"><span><img alt="image" class="svg" src="images/00005.jpeg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0003.vue?68e71072